import { render, staticRenderFns } from "./RobotConfigurationItem.vue?vue&type=template&id=f00948a4&scoped=true&"
import script from "./RobotConfigurationItem.vue?vue&type=script&lang=ts&"
export * from "./RobotConfigurationItem.vue?vue&type=script&lang=ts&"
import style0 from "./RobotConfigurationItem.vue?vue&type=style&index=0&id=f00948a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.8_m6jvttnwtqqy6l4pi5vsxiehsy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00948a4",
  null
  
)

export default component.exports